/**
 * Created by Jasmine on 2018/1/19.
 */

import { observable, computed, action } from "mobx";
import { request, apis } from '../../../utils/net';

const store = observable({
    codeList: [],         // 税收商品编码列表
    taxArr: [],           // 税率列表数组
    editData: {},         // 编辑编码当前列数据
    visible: false,       // 树弹窗,
    searchValue: {},      // 查询列表搜索条件
    defaultProject: {},   // 默认开票项目
    // tax_codeShow: false,  //是否为油类
    goodsNames: [], // 企业商品名称列表

    // 获取商品税率
    getTaxRate() {
        return request({
            url: apis.getTaxRate,
            method: 'GET',
        }).then(res => {
            // 过滤掉is_deleted的数据
            this.taxArr = (res || []).filter(item => item.is_deleted !== '1');
            return this.taxArr
        });
    },

    // 获取默认设置项目
    getDefaultProject() {
        let promise = request({
            url: apis.getDefaultProject,
            method: 'GET',
        });

        promise.then(res => {
            res && (this.defaultProject = res);
        });

        return promise
    },

    // 成都商户获取企业商品名称列表
    getGoodsNames(spmc) {
        return request({
            url: apis.getGoodsNames,
            method: 'GET',
            data: {
                spmc // 税收商品名称
            }
        }).then(res => {
            this.goodsNames = res
            if (res.length > 0) {
                // 强制更新 editData, 强制更新表单数据，避免税收商品名称错误
                const { editData: tmpEditData } = this
                this.editData = {}
                this.editData = Object.assign({}, tmpEditData, {
                    firm_goods_name: res[0].commodity_name
                })
            }
        })
    }
});

export default store;
